"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reflux = _interopRequireDefault(require("reflux"));

var _List = require("react-mdl/lib/List");

var _UserService = _interopRequireDefault(require("./services/UserService"));

var _UserLogsService = _interopRequireDefault(require("./services/UserLogsService"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _QuizHome = _interopRequireDefault(require("./QuizHome.scss"));

var _QuizLeagueHighScores = _interopRequireDefault(require("./QuizLeagueHighScores.scss"));

var _strings = require("../../../../config/strings");

var _QuizHighScoreStyle = require("./styles/QuizHighScoreStyle");

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var QuizLeagueHighscores = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizLeagueHighscores, _DataStoreComponent);

  var _super = _createSuper(QuizLeagueHighscores);

  function QuizLeagueHighscores(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, QuizLeagueHighscores);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateTab", function () {
      console.log('updating highscores');

      if (!_this.currentlyUpdating) {
        _this.updateHighscores();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateHighscores", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var user, userAuth;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.currentlyUpdating) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _this.currentlyUpdating = true;
              _context.prev = 3;
              user = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER];
              _context.next = 7;
              return _this.props.getAuthToken();

            case 7:
              userAuth = _context.sent;
              _context.next = 10;
              return _UserService["default"].loadLeagueSeasons(user.playgroupId, userAuth);

            case 10:
              _this.currentlyUpdating = false;
              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](3);
              console.log('ERROR: updating highscores', _context.t0);
              _this.currentlyUpdating = false;

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 13]]);
    })));
    _this.state = {
      scrollHeight: window.innerHeight - 250,
      scrollArrow: false,
      userDetails: null,
      userImage: false
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizLeagueHighscores.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_ALL_GAME, _DataStore.DATA_STORE_PATHS.QD_SEASONS, _DataStore.DATA_STORE_PATHS.QD_OPPONENTS, _DataStore.DATA_STORE_PATHS.QD_COMPLETED_GAME_IDS, _DataStore.DATA_STORE_PATHS.QD_EXPIRED_GAME_IDS, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizLeagueHighscores.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'quiz', 'navbar']
    }]);
    _this.showOrHideTimeout = null;
    _this.currentlyUpdating = false;
    return _this;
  } // componentDidMount () {
  //   if (!this.props.hidden) {
  //     this.onShowOrMount()
  //   }
  // }


  (0, _createClass2["default"])(QuizLeagueHighscores, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this2 = this;

      if (this.props.hidden === true && !prevProps.hidden) {
        clearTimeout(this.showOrHideTimeout);
        this.showOrHideTimeout = setTimeout(function () {// this.onHideOrUnmount()
        }, 500);
      } else if (!this.props.hidden && prevProps.hidden) {
        clearTimeout(this.showOrHideTimeout);
        this.showOrHideTimeout = setTimeout(function () {
          _this2.onShowOrMount();
        }, 500);
      }
    }
    /*
    componentWillReceiveProps (nextProps) {
      if (nextProps.hidden === true && !this.props.hidden) {
        clearTimeout(this.showOrHideTimeout)
        this.showOrHideTimeout = setTimeout(() => {
          this.isVisible = false
        }, 500)
      }
      else if (!nextProps.hidden && this.props.hidden) {
        clearTimeout(this.showOrHideTimeout)
        this.showOrHideTimeout = setTimeout(() => {
          this.onShowOrMount()
        }, 500)
      }
    }
    */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.showOrHideTimeout);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(QuizLeagueHighscores.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "onShowOrMount",
    value: function onShowOrMount() {
      // this.props.setTitle(getString('HIGHSCORES'));
      // LOG: user events
      _UserLogsService["default"].postLeagueHighScoreScreenViewedLog(this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id);

      _NavigationManager["default"].setCurrentLocation('quiz highscores');

      this.updateTab();
    }
  }, {
    key: "renderGroups",
    value: function renderGroups(sortedRegions) {
      var _this3 = this;

      var dynamicStyles = (0, _QuizHighScoreStyle.getStyles)(this.state);
      return sortedRegions.map(function (region, index) {
        return /*#__PURE__*/_react["default"].createElement(_List.ListItem, {
          key: "score_".concat(region.region),
          className: _QuizHome["default"].listItem
        }, /*#__PURE__*/_react["default"].createElement(_List.ListItemContent, {
          className: "".concat(_this3.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === region.region ? _QuizHome["default"].userText : _QuizHome["default"].opponentsText, " ").concat(_QuizLeagueHighScores["default"].text),
          style: _this3.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === region.region ? dynamicStyles.userPointsStyle : dynamicStyles.opponentPointsStyle
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].spanRank
        }, "".concat(region.rank, ".")), /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_QuizHome["default"].spanText, " ").concat(_QuizLeagueHighScores["default"].spanText)
        }, region.region)), /*#__PURE__*/_react["default"].createElement("div", {
          className: _this3.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === region.region ? _QuizHome["default"].userPoints : _QuizHome["default"].opponentPoints,
          style: _this3.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === region.region ? dynamicStyles.userPointsStyle : dynamicStyles.opponentPointsStyle
        }, region.averagePoints.toFixed(1).replace('.', ',')));
      });
    }
  }, {
    key: "render",
    value: function render() {
      // if(!this.state.groupUsers) {
      //   return (<div>loading...</div>);
      // }
      if (!this.state.data[_DataStore.DATA_STORE_PATHS.QD_SEASONS] || this.state.data[_DataStore.DATA_STORE_PATHS.QD_SEASONS].length === 0) {
        return null;
      }

      var dynamicStyles = (0, _QuizHighScoreStyle.getStyles)(this.state);

      var sortedRegions = this.state.data[_DataStore.DATA_STORE_PATHS.QD_SEASONS][0].regions.sort(function (obj1, obj2) {
        if (obj1.averagePoints < obj2.averagePoints) return 1;
        if (obj1.averagePoints > obj2.averagePoints) return -1;

        if (obj1.averagePoints === obj2.averagePoints) {
          if (obj1.region.toLowerCase() > obj2.region.toLowerCase()) return 1;
          if (obj1.region.toLowerCase() < obj2.region.toLowerCase()) return -1;
          return 0;
        }

        return 0;
      });

      sortedRegions.forEach(function (user, index) {
        if (index > 0) {
          if (user.points === sortedRegions[index - 1].points) {
            user.rank = sortedRegions[index - 1].rank;
          } else user.rank = index + 1;
        } else {
          user.rank = 1;
        }
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizLeagueHighScores["default"].header
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizLeagueHighScores["default"].headline
      }, this.state.data[_DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME]), /*#__PURE__*/_react["default"].createElement(_List.ListItem, {
        className: "".concat(_QuizHome["default"].listItem, " ").concat(_QuizLeagueHighScores["default"].listItem)
      }, /*#__PURE__*/_react["default"].createElement(_List.ListItemContent, {
        className: _QuizHome["default"].opponentsText,
        style: dynamicStyles.opponentPointsStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizHome["default"].spanRank
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizLeagueHighScores["default"].region
      }, "Region")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizLeagueHighScores["default"].points,
        style: dynamicStyles.opponentPointsStyle
      }, "\u2300-Punkte", /*#__PURE__*/_react["default"].createElement("br", null), "pro Spieler"))), /*#__PURE__*/_react["default"].createElement("div", {
        id: "innerContent",
        className: "".concat(_QuizHome["default"].innerContent, " ").concat(_QuizLeagueHighScores["default"].innerContent)
      }, this.renderGroups(sortedRegions)));
    }
  }]);
  return QuizLeagueHighscores;
}(_DataStoreComponent2["default"]);

exports["default"] = QuizLeagueHighscores;
QuizLeagueHighscores.propTypes = {
  showSpinner: _propTypes["default"].func.isRequired,
  onShowResults: _propTypes["default"].func.isRequired,
  onSetOpponent: _propTypes["default"].func.isRequired,
  getAuthToken: _propTypes["default"].func.isRequired,
  hidden: _propTypes["default"].bool
};